import type { TableDataColumn } from '@utilities/components/TableData/utilities/types';

/** Accessor of the compare-by segment label column in monadic/grid tables. */
export const COMPARE_BY_ACCESSOR = 'compare_by_breakout';

/** Accessors that identify the answer-option label column (never a data segment). */
export const OPTION_LABEL_ACCESSORS = ['ans_opt', 'option_value'];

/** Resolve a column's accessor: react-table `accessor`/`accessorKey`, else `id`. */
export const getColumnAccessor = (column: TableDataColumn): string | undefined =>
  column?.accessor || column?.accessorKey || (column as { id?: string })?.id;
